import store from "@/store";
import Axios from "axios";
import { Message } from "element-ui";

/**
 * 查询模型转换状态
 */
export const getConvertProgress = async modelId => {
    const res = await Axios.get<
        void,
        { status: { error: number }; convertStatus: number; progressDesc: string }
    >(`${process.env.VUE_APP_BORON}/Boron/GetConvertProgress?fileId=${modelId}`, {
        headers: {
            Authorization: `Bearer ${store.state.sessionId}`
        }
    });
    return res;
};

/**
 * 发起转换模型
 */
export const convertModel = async modelId => {
    const res = await Axios.post<
        {
            fileId: string;
            tessLevel?: number;
        },
        { status: { error: number }; convertStatus: number }
    >(
        `${process.env.VUE_APP_BORON}/Boron/ConvertFile`,
        {
            fileId: modelId,
            tessLevel: 0
        },
        {
            headers: {
                Authorization: `Bearer ${store.state.sessionId}`
            }
        }
    );
    return res;
};

export const checkModelConvertStatus = async (modelId: string) => {
    if (!store.state.sessionId) {
        await store.dispatch("getSessionId");
    }
    const getConvertProgressRes = await getConvertProgress(modelId);
    if (getConvertProgressRes.status.error === 20012) {
        await convertModel(modelId);
        Message.warning(`模型正在转换中。`);
        return false;
    }
    if (getConvertProgressRes.status.error === 0 && getConvertProgressRes.convertStatus === 0) {
        return true;
    }
    if (getConvertProgressRes.convertStatus === 1) {
        Message.warning(
            `模型正在转换中。${
                getConvertProgressRes.progressDesc
                    ? `进度：${getConvertProgressRes.progressDesc}`
                    : ""
            }`
        );
        return false;
    }
    if (getConvertProgressRes.status.error !== 0) {
        Message.warning(`模型转换失败，请联系管理员或更换模型。`);
        return false;
    }
    return false;
};
